import { useRoutes } from "react-router-dom";
import { MainRoutes } from "./MainRoutes";
import { AboutUsRoutes } from "./AboutUsRoutes";
import { QuestionnairesRoutes } from "./QuestionnairesRoutes";
import { TrimixRoutes } from "./TrimixRoutes";
import { OralMedRoutes } from "./OralMedRoutes";
import { ContactUsRoutes } from "./ContactUsRoutes";
import { LoginRoutes } from "./LoginRoutes";
import { DashboardRoutes } from "./DashboardRoutes";
import { HealthQuestionnairesRoutes } from "./HealthQuestionnairesRoutes";
import { ProductsRoutes } from "./ProductsRoutes";
import { VendorInformationRoutes } from "./VendorInformationRoutes";
import { PatientBillOfRightsRoutes } from "./PatientBillOfRightsRoutes";
import { ResetPasswordRoutes } from "./ResetPasswordRoutes";
import { PageNotFoundRoutes } from "./PageNotFoundRoutes";
import { CheckoutPageRoutes } from "./CheckoutPageRoutes";
import { SelfSchedulePageRoutes } from "./SelfSchedulePageRoutes";

export default function AppRoutes() {
  const routes = useRoutes([
    MainRoutes,
    AboutUsRoutes,
    QuestionnairesRoutes,
    TrimixRoutes,
    OralMedRoutes,
    ContactUsRoutes,
    LoginRoutes,
    DashboardRoutes,
    HealthQuestionnairesRoutes,
    ProductsRoutes,
    VendorInformationRoutes,
    PatientBillOfRightsRoutes,
    ResetPasswordRoutes,
    CheckoutPageRoutes,
    PageNotFoundRoutes,
    SelfSchedulePageRoutes
  ]);
  return routes;
}
